import React from 'react';
import { IconProps } from '../types';
const MinecraftBrownDye: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="4" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(153, 93, 51, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(201, 128, 77, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(201, 128, 77, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(153, 93, 51, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(153, 93, 51, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(201, 128, 77, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(201, 128, 77, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(153, 93, 51, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(153, 93, 51, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(153, 93, 51, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(153, 93, 51, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(201, 128, 77, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(153, 93, 51, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(153, 93, 51, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="14" y="8" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(201, 128, 77, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(153, 93, 51, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(153, 93, 51, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(122, 70, 33, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(99, 44, 4, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(66, 31, 5, 255)" />
</svg>);
export default MinecraftBrownDye;